import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { SELECTION_ALL } from '../../common/constants';
import { useTranslation } from 'react-i18next';

const CompanyDropdown = ({ onChange, companyID }) => {
  const { t } = useTranslation();
  const companies = useSelector(state => 
  (state.Admin.company || [])
    .slice() // clone the array
    .sort((a, b) => a.name.localeCompare(b.name)) // sort by name (ascending)
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // Use null or a special value for "All"
  const [selectedCompanyId, setSelectedCompanyId] = useState(companyID || SELECTION_ALL);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  // Find the selected company object (if not "all")
  const selectedCompany = companies.find(c => c.id === selectedCompanyId);

  // Handle selection change
  const handleSelect = (id) => {
    setSelectedCompanyId(id);
    if (onChange) {
      onChange(id);
    }
  };

  useEffect(() => {
    setSelectedCompanyId(companyID || SELECTION_ALL);
  }, [companyID]);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary" className="mb-2 me-2 ms-2">
        {selectedCompanyId === SELECTION_ALL
          ? t('PageAdmin.SelectAllCompanies')
          : (selectedCompany ? selectedCompany.name : t('PageAdmin.SelectCompany'))}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          key={SELECTION_ALL}
          onClick={() => handleSelect(SELECTION_ALL)}
          active={selectedCompanyId === SELECTION_ALL}
        >
          {t('PageAdmin.SelectAllCompanies')}
        </DropdownItem>
        {companies.map(company => (
          <DropdownItem
            key={company.id}
            onClick={() => handleSelect(company.id)}
            active={selectedCompanyId === company.id}
          >
            {company.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CompanyDropdown;
